import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a537980cba60ecbb36e1473210a8c63edb from "./generated-a3d8f12c-d779-4a7e-b650-ec0c9491d233.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/bookmaker-settings"){
            
                    await direct(a537980cba60ecbb36e1473210a8c63edb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */